import { MilanoteHotPlugin } from './MilanoteHotPlugin';

export const CONTEXT_MENU_SHORTCUTS_PLUGIN_NAME = 'ContextMenuShortcuts';

const CONTEXT_MENU_SHORTCUT_CONTEXT = 'menu';
const CONTEXT_MENU_ARROW_SHORTCUT_GROUP = 'milanoteTableShortcuts.contextMenuArrowStopPropagation';

/**
 * Registers Milanote-specific context menu shortcuts for the non-legacy table.
 */
export default class ContextMenuShortcutsHotPlugin extends MilanoteHotPlugin {
    static get PLUGIN_KEY(): string {
        return CONTEXT_MENU_SHORTCUTS_PLUGIN_NAME;
    }

    enablePlugin(): void {
        this.addHook('afterContextMenuShow', () => this.registerShortcuts());
        this.addHook('afterContextMenuHide', () => this.unregisterShortcuts());

        super.enablePlugin();
    }

    disablePlugin(): void {
        this.unregisterShortcuts();

        super.disablePlugin();
    }

    registerShortcuts(): void {
        // @ts-ignore - Handsontable private property
        const menu = this.milanoteHot.getPlugin('contextMenu')?.menu;
        const shortcutContext = menu?.hotMenu?.getShortcutManager()?.getContext(CONTEXT_MENU_SHORTCUT_CONTEXT);

        if (!shortcutContext) return;

        shortcutContext.removeShortcutsByKeys(['ArrowUp']);
        shortcutContext.removeShortcutsByKeys(['ArrowRight']);
        shortcutContext.removeShortcutsByKeys(['ArrowDown']);
        shortcutContext.removeShortcutsByKeys(['ArrowLeft']);

        shortcutContext.addShortcuts([
            {
                // Stop context-menu arrow presses from bubbling into Milanote shortcut handlers.
                keys: [
                    ['ArrowUp'],
                    ['ArrowRight'],
                    ['ArrowDown'],
                    ['ArrowLeft'],
                    ['Shift', 'ArrowUp'],
                    ['Shift', 'ArrowRight'],
                    ['Shift', 'ArrowDown'],
                    ['Shift', 'ArrowLeft'],
                ],
                callback: () => {},
                stopPropagation: true,
                group: CONTEXT_MENU_ARROW_SHORTCUT_GROUP,
            },
        ]);
    }

    unregisterShortcuts(): void {
        // @ts-ignore - Handsontable private property
        const menu = this.milanoteHot.getPlugin('contextMenu')?.menu;
        const shortcutContext = menu?.hotMenu?.getShortcutManager()?.getContext(CONTEXT_MENU_SHORTCUT_CONTEXT);

        if (!shortcutContext) return;

        shortcutContext.removeShortcutsByGroup(CONTEXT_MENU_ARROW_SHORTCUT_GROUP);
    }
}
